"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled = __importStar(require("./styled"));
const Typography_1 = __importStar(require("../../../UI/Typography"));
const Hooks_1 = require("@/Hooks");
const VolumeDiscount = ({ discountInfo }) => {
    const { t } = (0, Hooks_1.useTranslate)();
    return (react_1.default.createElement(styled.VolumeDiscount, null,
        react_1.default.createElement(styled.VolumeDiscountTitle, { type: Typography_1.Types.BODY_2 }, t('/haldex/add_to_cart/volume_discount')),
        discountInfo.map((el, index) => (react_1.default.createElement("div", { key: index },
            react_1.default.createElement(Typography_1.default, { type: Typography_1.Types.BODY_2 }, el.price),
            react_1.default.createElement(Typography_1.default, { type: Typography_1.Types.BODY_2 }, el.info))))));
};
exports.default = VolumeDiscount;
